<section class="py-0" aria-labelledby="organization-receives-heading">
  <div class="mb-3">
    <h2 id="organization-receives-heading" class="h3 fw-bold mb-2">
      How much of the fundraiser does your organization keep?
    </h2>
    <p class="text-body-secondary mb-0">
      Bars show the share of the original online fundraiser retained by the
      organization. Supporter-paid extras are shown separately.
    </p>
  </div>

  <ul
    class="list-unstyled d-flex flex-wrap gap-2 gap-md-3 small text-body-secondary mb-3"
    aria-label="Platform category legend"
  >
    <li
      *ngFor="let category of categories; trackBy: trackCategory"
      class="d-inline-flex align-items-center gap-1"
    >
      <i class="bi" [ngClass]="category.iconClass" aria-hidden="true"></i>
      <span>{{ category.legendLabel }}</span>
    </li>
  </ul>

  <ul class="list-group list-group-flush border rounded-3 overflow-hidden mb-0">
    <li
      *ngFor="let row of rows; trackBy: trackRow"
      class="list-group-item list-group-item-action p-0"
      role="listitem"
    >
      <button
        type="button"
        class="btn text-body text-start w-100 rounded-0 px-3 py-3 focus-ring"
        data-bs-toggle="offcanvas"
        data-bs-target="#fundraisingPlatformQuickView"
        aria-controls="fundraisingPlatformQuickView"
        [attr.data-platform-id]="row.result.platformId"
        [attr.aria-label]="rowAriaLabel(row)"
        (click)="quickViewRequested.emit(row.result.platformId)"
      >
        <span class="row g-2 g-md-3 align-items-center">
          <span class="col-12 col-md-4 col-lg-3">
            <span class="d-flex align-items-center gap-2 fw-semibold">
              <i
                class="bi flex-shrink-0"
                [ngClass]="categoryFor(row.categoryId)?.iconClass"
                aria-hidden="true"
              ></i>
              <span>{{ row.result.platformName }}</span>
            </span>
          </span>
          <span class="col-12 col-md-8 col-lg-5">
            <svg
              class="d-block w-100 text-primary"
              viewBox="0 0 100 8"
              preserveAspectRatio="none"
              focusable="false"
              aria-hidden="true"
            >
              <rect
                class="text-body-tertiary"
                fill="currentColor"
                x="0"
                y="0"
                width="100"
                height="8"
                rx="2"
              ></rect>
              <rect
                fill="currentColor"
                x="0"
                y="0"
                [attr.width]="row.retentionPercentage"
                height="8"
                rx="2"
              ></rect>
            </svg>
          </span>
          <span
            class="col-5 col-md-5 col-lg-2 text-md-end fw-semibold text-nowrap"
            data-retention-summary
          >
            {{ retentionSummary(row) }}
          </span>
          <span
            class="col-7 col-md-7 col-lg-2 text-end fw-semibold text-nowrap"
          >
            {{ formatMoney(row.organizationReceivesCents) }}
          </span>
        </span>
        <span
          class="d-flex flex-column flex-lg-row flex-wrap align-items-lg-center column-gap-3 row-gap-1 mt-2"
        >
          <span *ngIf="row.configurationSummary" class="text-body-secondary">
            {{ row.configurationSummary }}
          </span>
          <span
            *ngIf="row.supporterPaidIndicator"
            class="d-inline-flex align-items-center gap-1 lh-sm text-body-secondary"
            data-supporter-paid-indicator
          >
            <i class="bi bi-plus-circle flex-shrink-0" aria-hidden="true"></i>
            <span>{{ supporterPaidText(row) }}</span>
          </span>
          <span class="fw-semibold text-primary text-nowrap ms-lg-auto">
            Configure
            <span aria-hidden="true">›</span>
          </span>
        </span>
      </button>
    </li>
  </ul>

  <p class="small text-body-secondary mt-3 mb-0">
    These platforms provide different levels of service. This comparison focuses
    on fundraising economics, not overall product value.
  </p>
</section>
